import React from 'react';
import api from 'Components/_helpers/api';

export const useEmpresas = (defaultEmpresas = []) => {
  const [empresas, setEmpresas] = React.useState(defaultEmpresas);
  const [loadingData, setLoadingData] = React.useState(false);
  const featEmpresas = (word) => {
    if (word) {
      setLoadingData(true);
      api
        .get(`${api.getUri()}Search/empresa?q=${word}`)
        .then((res) => {
          setEmpresas(res.data);
          setLoadingData(false);
        })
        .catch((e) => console.log('error', e));
    }
  };

  return [empresas, loadingData, featEmpresas];
};
